import { Route } from "react-router-dom";
import Protected from "../components/Protected";
import Locations from "../pages/Admin-pages/CA-admin-pages/Locations";
import ClientAdminProtected from "../components/ClinetAdminProtected";
import WorkRoleListing from "../pages/Admin-pages/CA-admin-pages/WorkRoleListing";
import EditContainer from "../pages/Admin-pages/CAAdminCoursePages/WorkRoleTabs/EditContainer";
const DynamicRoutes = () => {
  const routes = [
    <Route
      key="view-notifications-route-154"
      path="/settings/locations"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <Locations />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="view-notifications-route-154732"
      path="/settings/work-roles"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <WorkRoleListing />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="view-notifications-route-15324732"
      path="/settings/work-roles/edit/:id"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <EditContainer />
          </ClientAdminProtected>
        </Protected>
      }
    />,
  ];
  return routes;
};
export default DynamicRoutes;
